import { render, staticRenderFns } from "./IndexType.vue?vue&type=template&id=34fb05d5"
import script from "./IndexType.vue?vue&type=script&lang=js"
export * from "./IndexType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports